import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
    return <Slide direction="up" {...props} />;
  }

export default class SimpleDialog extends React.Component{
    constructor(props){
        super(props);
        this.state = {open:false,message:null,callBack:null}
    }

    show(message,callBack){
        this.setState({open:true,message:message,callBack:callBack});
    }

    handleClose = () => {
        this.setState({ open: false });
        if(this.state.callBack){
            this.state.callBack(false);
        }
    };

    handleOkay = () => {
        this.setState({open:false});
        if(this.state.callBack){
            this.state.callBack(true);
        }
    };

    render(){
        return(
            <Dialog
          open={this.state.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" style={{backgroundColor:'red',marginBottom:'2em'}}>
            {"Delete?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {this.state.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleOkay} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        );
    }
}